$('#search_format, #search_service').on('change', function () {
    // submit the form
    var form = document.querySelector('form');
    //form.submit();
    //$(this).parents('form').find('input[type=submit]').trigger('click')
    //$(this).parents('form').submit();
    Rails.fire(form, 'submit');
});